import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { useFormikContext } from 'formik';

import {
  updateMultipleQueryStringOnFieldChange,
  updateQueryStringOnFieldChange,
} from '@components/Filters/Filters';
import { countryApi } from '@reducers/geo';
import { planApi } from '@reducers/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const PSTNUpgradeFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { handleChange, handleBlur, values, setFieldValue } =
    useFormikContext();

  const countries = countryApi.useGetForSelectQuery();
  const plans = planApi.useGetPSTNForSelectQuery(
    values.country ? { id: values.country } : skipToken
  );

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Search</Card.Header>
      <Card.Body>
        <Form.Group className="mb-3" controlId="formGroupCountry">
          <Form.Label>Country</Form.Label>
          <Form.Select
            name="country"
            size="sm"
            value={values.country}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                clearFields: ['plan', 'type'],
                searchParams,
                setSearchParams,
              });
            }}
            onBlur={handleBlur}
          >
            <option value="">Select country</option>
            {!countries.isLoading &&
            !countries.isError &&
            countries.data.length > 0 ? (
              <>
                {countries.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
        </Form.Group>
        <Form.Label>Plan</Form.Label>
        <Form.Select
          className="mb-3"
          name="plan"
          size="sm"
          value={`${values.plan}-${values.type}`}
          disabled={plans.isLoading || plans.isFetching || !values.country}
          onChange={(e) => {
            const { dataset } = e.target.options[e.target.selectedIndex];
            handleChange(
              e.target.name,
              `${e.target.value}-${dataset.plantype}`,
              dataset.plantype
            );
            setFieldValue('type', dataset.plantype || '');

            updateMultipleQueryStringOnFieldChange(
              [
                { name: e.target.name, value: dataset.planid },
                { name: 'type', value: dataset.plantype || '' },
              ],
              {
                searchParams,
                setSearchParams,
              }
            );
          }}
          onBlur={handleBlur}
        >
          {plans.isLoading ? <option>Loading...</option> : null}
          <option value="">
            {values.country ? 'Select plan' : 'Select country to see plans'}
          </option>

          {!plans.isUninitialized &&
          !plans.isLoading &&
          !plans.isFetching &&
          !plans.isError &&
          plans.data.length > 0
            ? plans.data.map(({ value, name, plan_type: type }) => (
                <option
                  key={`${value}-${type}-${name}`}
                  value={`${value}-${type}`}
                  data-plantype={type}
                  data-planid={value}
                >
                  {name}
                </option>
              ))
            : null}
        </Form.Select>
      </Card.Body>
    </Card>
  );
};
